import React, { useState } from "react";
// import axios from "axios";
import Sectiontitle from "./sectiontitle";
import Pagination from "./pagination";
import PortafoliosView from "./portafoliosView";

import usePortafolio from '../hooks/use-portafolio';


const Portafolios = () => {

    const portfolios = usePortafolio();

    const [currentPage, setCurrentPage] = useState(1);
    const [portfoliosPerPage] = useState(9);

    const indexOfLastPortfolios = currentPage * portfoliosPerPage;
    const indexOfFirstPortfolios = indexOfLastPortfolios - portfoliosPerPage;
    const currentPortfolios = portfolios.slice(
        indexOfFirstPortfolios,
        indexOfLastPortfolios
    );

    const paginate = (e, pageNumber) => {
        e.preventDefault();
        setCurrentPage(pageNumber);
    };

    return (  
        <section id="portafolios">
            <div className="mi-about mi-section py-5">
                <div className="container">
                    <Sectiontitle title="My work" />
                    {<PortafoliosView portfolios={currentPortfolios} />}
                    <Pagination
                        className="mt-5"
                        itemsPerPage={portfoliosPerPage}
                        totalItems={portfolios.length}
                        paginate={paginate}
                        currentPage={currentPage}
                    />
                </div>
            </div>
        </section>
    );
}
 
export default Portafolios;